<template>
  <div id="wrapper">
    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <h3 class="font-light m-b-xs">
            CROP Home
          </h3>
          <small>Welcome to the CROP platform**
            of Orange Labs dedicated to Open Innovation</small>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="row" >
        <div class="col-lg-12">
          <div class="hpanel horange">
            <div class="panel-body info">
              For any information or registration, contact
              <a href="mailto:laurent.bouskela@orange.com" class="text-warning">laurent.bouskela@orange.com</a> or
              <a href="mailto:yasmine.faik@orange.com" class="text-warning">yasmine.faik@orange.com</a>

            </div>
          </div>
        </div>

      </div>
      <div class="row" >
        <div class="col-lg-12">
          <div class="hpanel">
            <div class="panel-body info">
              <p class="text-center m-b"><big>
                This platform is designed to facilitate the implementation of Externalized Contracts of Research (CRE)<br>
                by helping users to specify their needs, identify potential partners and then contact them.
                <br>
                <a :href="websiteUrl + '/crop-public-questions'" class="text-warning m-t-sm" target="_blank" >See the list of Orange scientific challenges</a>
              </big>
              </p>
              <p class="text-center m-b">
                <img v-bind:src="$apiUrl +'/orange/en-orange-plateforme-CRE.png' " alt="CROP Platform"/>
              </p>
              <p class="m-b-md">
                <strong>The platform has been developed around a search engine and a workflow that allow:</strong>
              </p>
              <ul class="m-b-lg">
                <li class="m-b-xs">To quickly establish a state-of- the-art on any technical or scientific field,
                  giving access to more than 200 million documents (publications, patents)</li>
                <li class="m-b-xs">To write a question that one would like to ask to external experts of the academic world
                  - the platform lists more than 10 million experts and a million companies -</li>
                <li class="m-b-xs">To identify the experts most relevant to the issue and contact them</li>
                <li class="m-b-xs">To identify and visualize the calls for projects of Orange Labs</li>
              </ul>
              <div class="clearfix m-b m-t text-center">
               <span class="text-info"> For any help, log on the Assistance bubble at the bottom right. </span>
              </div>

              <div class="col-lg-12 m-t m-b-md">
                <p class="m-b-sm">
                  <u>
                    <i>Contract documents are available:
                      <a :href="$apiUrl +'/orange/rules_for_submission_of_proposals_CROP.pdf'" class="text-warning" target="_blank">
                        Rules for submission of proposals</a>
                    </i>
                  </u>
                </p>
                <p id="crop" class="m-t"><i>**CROP: Call for Research Open Platform</i></p>
                <p class="text-right m-b-xs"><i> version 1.1 sept 2017</i></p>
                <p class="text-right  m-t-xs">
                  <a :href="$apiUrl +'/orange/legal-informations-orange-idexlab.pdf'" class="text-warning " target="_blank">
                    <u>[Legal Information]</u></a>
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="showVideo === true">
      <video-modal :videoUrl="videoUrl" v-model="showVideo"></video-modal>
    </template>
  </div>
</template>

<script>
import VideoModal from '../../components/modal/VideoModal'
export default {
  name: 'CropHome',
  components: {VideoModal},
  data () {
    return {
      websiteUrl: process.env.WEBSITE_URL,
      showVideo: false,
      videoUrl: 'https://www.youtube.com/embed/GSaItwT9z_U?rel=0&showinfo=0&modestbranding=1&autoplay=1'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/CropHome.vue